var _desc, _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgScimBridge(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "256px",
    height: "256px",
    viewBox: "0 0 256 256",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "SCIM Bridge") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "SCIM Bridge logo.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50.6649657%",
    y1: "0.664965679%",
    x2: "50.6649657%",
    y2: "99.3350343%",
    id: "linearGradient-1"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#000000",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#000000",
    stopOpacity: 0,
    offset: "100%"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M167.21693,74.270429 L183.21693,77.8259845 C183.674468,77.9276596 184,78.333473 184,78.8021716 L184,160.538155 C184,161.09044 183.552285,161.538155 183,161.538155 C182.876014,161.538155 182.753109,161.515098 182.637554,161.47016 L166.637554,155.247938 C166.253182,155.09846 166,154.728347 166,154.315933 L166,75.2466161 C166,74.6943313 166.447715,74.2466161 167,74.2466161 C167.072962,74.2466161 167.145706,74.2546012 167.21693,74.270429 Z",
    id: "path-2"
  }), /*#__PURE__*/React.createElement("filter", {
    x: "-16.7%",
    y: "-3.4%",
    width: "133.3%",
    height: "106.9%",
    filterUnits: "objectBoundingBox",
    id: "filter-3"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: -4,
    dy: -4,
    in: "SourceAlpha",
    result: "shadowOffsetInner1"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "shadowOffsetInner1",
    in2: "SourceAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1,
    result: "shadowInnerInner1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.1465976 0",
    type: "matrix",
    in: "shadowInnerInner1"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M72.7830695,79.6279452 L88.7830695,76.0723897 C89.3222028,75.9525823 89.8563797,76.292513 89.9761871,76.8316463 C89.9920148,76.9028712 90,76.9756144 90,77.0485767 L90,155.117894 C90,155.530307 89.7468177,155.90042 89.3624463,156.049898 L73.3624463,162.27212 C72.8477143,162.472294 72.2681689,162.217294 72.0679953,161.702562 C72.0230571,161.587007 72,161.464102 72,161.340116 L72,80.6041323 C72,80.1354336 72.325532,79.7296202 72.7830695,79.6279452 Z",
    id: "path-4"
  }), /*#__PURE__*/React.createElement("filter", {
    x: "-22.2%",
    y: "-4.6%",
    width: "144.4%",
    height: "109.3%",
    filterUnits: "objectBoundingBox",
    id: "filter-5"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 4,
    dy: -6,
    in: "SourceAlpha",
    result: "shadowOffsetInner1"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "shadowOffsetInner1",
    in2: "SourceAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1,
    result: "shadowInnerInner1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.1465976 0",
    type: "matrix",
    in: "shadowInnerInner1"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M233.000883,207 C229.28016,207 228.03751,207 216,207 C214.666667,207 212.917055,205.666667 210.751165,203 C191.325062,181.0529 161.474596,167 128,167 C94.5254043,167 64.6749385,181.0529 45.2488349,203 C43.082945,205.666667 41.3333333,207 40,207 L26,207 L26,189 L25.7044804,189 C49.7064289,160.993715 87.4495951,143 129,143 C172.10992,143 209.516117,162.369783 233,192.195356 L233,207 Z",
    id: "path-6"
  }), /*#__PURE__*/React.createElement("filter", {
    x: "-2.4%",
    y: "-7.8%",
    width: "104.8%",
    height: "115.6%",
    filterUnits: "objectBoundingBox",
    id: "filter-7"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 8,
    in: "SourceAlpha",
    result: "shadowOffsetInner1"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "shadowOffsetInner1",
    in2: "SourceAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1,
    result: "shadowInnerInner1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.0801064312 0",
    type: "matrix",
    in: "shadowInnerInner1"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M24.9451777,188.349262 L24.3893617,184.444837 C29.4433153,178.547713 31.0560606,173.0816 37.1574716,168.104616 L40.9500115,172.753985 C35.1229746,177.507161 29.7658953,182.724286 24.9451777,188.349262 Z M44.0201771,170.325916 L40.3695834,165.564281 C46.5276785,160.843066 53.1235299,156.620822 60.0769887,152.946152 L62.880398,158.250951 C56.2227931,161.769273 49.9104421,165.810038 44.0201771,170.325916 Z M66.3508401,156.47971 L63.6995104,151.09729 C70.6648137,147.666247 77.9390835,144.786182 85.439404,142.492401 L87.1941261,148.230079 C80.0012286,150.429842 73.026824,153.191183 66.3508401,156.47971 Z M90.9833481,147.128825 L89.3893395,141.344437 C96.8837581,139.279194 104.560677,137.800243 112.341305,136.929063 L113.00894,142.891803 C105.541539,143.727911 98.1743616,145.147191 90.9833481,147.128825 Z M116.852032,142.513807 L116.345121,136.535258 C120.542126,136.179401 124.759922,136.000362 128.987423,136.000001 C132.585684,136 136.157058,136.128644 139.708248,136.38529 L139.275754,142.369682 C135.868628,142.123448 132.441513,142 128.98768,142.000001 C124.929636,142.000348 120.880789,142.172215 116.852032,142.513807 Z M143.185847,142.707047 L143.784968,136.737034 C151.610605,137.522376 159.302593,138.931543 166.793766,140.945763 L165.235826,146.739969 C158.05926,144.81034 150.687944,143.45992 143.185847,142.707047 Z M168.998229,147.810031 L170.722811,142.063221 C178.246321,144.32098 185.528473,147.191021 192.497543,150.641663 L189.835202,156.018645 C183.168186,152.717562 176.199753,149.971163 168.998229,147.810031 Z M193.294785,157.795835 L196.11519,152.500053 C203.03425,156.184976 209.600063,160.443795 215.743464,165.232545 L212.05476,169.964717 C206.184529,165.388903 199.909288,161.318559 193.294785,157.795835 Z M215.085883,172.402295 L218.916551,167.784288 C224.938324,172.77939 226.502805,178.285949 231.550146,184.251552 L230.969648,188.126992 C226.150431,182.431015 220.836949,177.172843 215.085883,172.402295 Z",
    id: "path-8"
  }), /*#__PURE__*/React.createElement("filter", {
    x: "-1.4%",
    y: "-5.7%",
    width: "102.9%",
    height: "111.5%",
    filterUnits: "objectBoundingBox",
    id: "filter-9"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 2,
    in: "SourceAlpha",
    result: "shadowOffsetInner1"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "shadowOffsetInner1",
    in2: "SourceAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1,
    result: "shadowInnerInner1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 1   0 0 0 0 1   0 0 0 0 1  0 0 0 0.15 0",
    type: "matrix",
    in: "shadowInnerInner1"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M24,98 L44,98 C45.1045695,98 46,98.8954305 46,100 L46,206 C46,207.104569 45.1045695,208 44,208 L24,208 C22.8954305,208 22,207.104569 22,206 L22,100 C22,98.8954305 22.8954305,98 24,98 Z",
    id: "path-10"
  }), /*#__PURE__*/React.createElement("filter", {
    x: "-18.8%",
    y: "-4.1%",
    width: "137.5%",
    height: "108.2%",
    filterUnits: "objectBoundingBox",
    id: "filter-11"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 4,
    dy: -5,
    in: "SourceAlpha",
    result: "shadowOffsetInner1"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "shadowOffsetInner1",
    in2: "SourceAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1,
    result: "shadowInnerInner1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.1465976 0",
    type: "matrix",
    in: "shadowInnerInner1"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M212,97 L232,97 C233.104569,97 234,97.8954305 234,99 L234,205 C234,206.104569 233.104569,207 232,207 L212,207 C210.895431,207 210,206.104569 210,205 L210,99 C210,97.8954305 210.895431,97 212,97 Z",
    id: "path-12"
  }), /*#__PURE__*/React.createElement("filter", {
    x: "-18.8%",
    y: "-4.1%",
    width: "137.5%",
    height: "108.2%",
    filterUnits: "objectBoundingBox",
    id: "filter-13"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: -4,
    dy: -5,
    in: "SourceAlpha",
    result: "shadowOffsetInner1"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "shadowOffsetInner1",
    in2: "SourceAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1,
    result: "shadowInnerInner1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.1465976 0",
    type: "matrix",
    in: "shadowInnerInner1"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M10,120.812358 C10,114.208239 10,107.604119 10,101 C10,99 10.6666667,97.5355295 12,96.6065886 C45.5654884,72.4900115 85.6027525,59 128,59 C170.395146,59 210.435264,72.4903934 244.000025,96.6057075 C245.333342,97.5352358 246,99 246,101 C246,107.722026 246,114.444052 246,121.166078 L246,121.166078 C246,122.270648 245.104569,123.166078 244,123.166078 C243.590733,123.166078 243.191317,123.04052 242.855663,122.80635 L235.33895,117.562308 C204.593938,94.137765 167.447149,81 128,81 C88.5538947,81 51.4131117,94.1351973 20.6683566,117.557734 L13.090842,122.488683 C12.1650335,123.091138 10.9261309,122.829009 10.3236755,121.9032 C10.1124432,121.578594 10,121.199641 10,120.812358 Z",
    id: "path-14"
  }), /*#__PURE__*/React.createElement("filter", {
    x: "-1.5%",
    y: "-5.5%",
    width: "103.0%",
    height: "110.9%",
    filterUnits: "objectBoundingBox",
    id: "filter-15"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: -5,
    in: "SourceAlpha",
    result: "shadowOffsetInner1"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "shadowOffsetInner1",
    in2: "SourceAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1,
    result: "shadowInnerInner1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.1465976 0",
    type: "matrix",
    in: "shadowInnerInner1",
    result: "shadowMatrixInner1"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 5,
    in: "SourceAlpha",
    result: "shadowOffsetInner2"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "shadowOffsetInner2",
    in2: "SourceAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1,
    result: "shadowInnerInner2"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 1   0 0 0 0 1   0 0 0 0 1  0 0 0 0.116706295 0",
    type: "matrix",
    in: "shadowInnerInner2",
    result: "shadowMatrixInner2"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "shadowMatrixInner1"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "shadowMatrixInner2"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50%",
    y1: "0%",
    x2: "50%",
    y2: "100%",
    id: "linearGradient-16"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0073E5",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00B9F9",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50%",
    y1: "0%",
    x2: "50%",
    y2: "100%",
    id: "linearGradient-17"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#000000",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#000000",
    stopOpacity: 0,
    offset: "100%"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M40.0001095,16 C53.2549868,16 64,26.7450852 64,40 C64,53.2549148 53.2549868,64 40.0001095,64 C26.7452323,64 16,53.2549148 16,40 C16,26.7450852 26.7452323,16 40.0001095,16 L40.0001095,16 Z",
    id: "path-18"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-0.438596491,10.4305185 L-0.438596491,1.86909596 C-0.438596491,1.14687745 0.121047571,0.561403666 0.811403509,0.561403666 L8.31140351,0.561403509 C9.00175945,0.561403509 9.56140351,1.14687729 9.56140351,1.8690958 L9.56140142,18.720585 C9.56140138,19.0607676 9.43468581,19.3875608 9.20814846,19.631607 L8.12784292,20.795408 C7.65683896,21.3028153 7.65683896,22.1100449 8.12784292,22.6174522 L9.2081485,23.7812533 C9.43468583,24.0252994 9.5614014,24.3520926 9.56140147,24.6922751 L9.56140351,33.2537109 C9.56140366,33.9759294 9.00175972,34.5614034 8.31140378,34.5614035 L0.811403509,34.5614032 C0.121047571,34.5614032 -0.438596491,33.9759294 -0.438596491,33.2537109 L-0.438596491,16.4022088 C-0.438596491,16.0620262 -0.311880918,15.735233 -0.0853435267,15.4911868 L0.994961951,14.3273857 C1.4659659,13.8199784 1.4659659,13.0127489 0.994961951,12.5053416 L-0.0853435267,11.3415406 C-0.311880918,11.0974944 -0.438596491,10.7707011 -0.438596491,10.4305185 Z",
    id: "path-19"
  }), /*#__PURE__*/React.createElement("filter", {
    x: "-5.0%",
    y: "-1.5%",
    width: "110.0%",
    height: "105.9%",
    filterUnits: "objectBoundingBox",
    id: "filter-20"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 1,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 1   0 0 0 0 1   0 0 0 0 1  0 0 0 1 0",
    type: "matrix",
    in: "shadowOffsetOuter1"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Artboard-2",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.9943996,207.830651 C50.2547342,204.610217 88.756601,203 127.5,203 C166.254591,203 205.089739,204.611147 244.005445,207.833442 L244.005443,207.833464 C245.132673,207.926801 246,208.868913 246,210 L246,210 C246,211.104569 245.104569,212 244,212 L12,212 C10.8954305,212 10,211.104569 10,210 L10,210 C10,208.868464 10.8668532,207.925582 11.9944015,207.830674 Z",
    id: "Rectangle-7",
    fillOpacity: 0.0808990036,
    fill: "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.60952,220.726277 C193.386014,219.908759 203.182841,219.5 213,219.5 C222.817159,219.5 232.613986,219.908759 242.39048,220.726277 L242.39048,220.726273 C242.735026,220.755084 243,221.04314 243,221.388889 L243,221.388889 C243,221.732886 242.733042,222.017848 242.389776,222.040267 C232.593184,222.680089 222.796592,223 213,223 C203.203408,223 193.406816,222.680089 183.610224,222.040268 L183.610224,222.040267 C183.266958,222.017848 183,221.732886 183,221.388889 L183,221.388889 C183,221.04314 183.264974,220.755084 183.60952,220.726273 Z",
    id: "Rectangle-7",
    fillOpacity: 0.0808990036,
    fill: "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42,207 C61.2183495,182.774902 92.5775805,167 128,167 C163.42242,167 194.781651,182.774902 214,207 L42,207 Z",
    id: "Combined-Shape",
    fill: "url(#linearGradient-1)",
    opacity: 0.0799999982
  }), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle-4",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#2F92F8",
    fillRule: "evenodd",
    xlinkHref: "#path-2"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "black",
    fillOpacity: 1,
    filter: "url(#filter-3)",
    xlinkHref: "#path-2"
  }), /*#__PURE__*/React.createElement("use", {
    stroke: "#1063B8",
    strokeWidth: 2,
    xlinkHref: "#path-2"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle-4-Copy",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#2F92F8",
    fillRule: "evenodd",
    xlinkHref: "#path-4"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "black",
    fillOpacity: 1,
    filter: "url(#filter-5)",
    xlinkHref: "#path-4"
  }), /*#__PURE__*/React.createElement("use", {
    stroke: "#1063B8",
    strokeWidth: 2,
    xlinkHref: "#path-4"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M117,75 L139,75 C139.552285,75 140,75.4477153 140,76 L140,111.171573 C140,111.702006 139.789286,112.210714 139.414214,112.585786 L135.102451,116.897549 C133.938273,118.061727 133.929852,119.946619 135.083582,121.121152 L139.426793,125.542678 C139.794162,125.916671 140,126.419956 140,126.944199 L140,154 C140,154.552285 139.552285,155 139,155 L117,155 C116.447715,155 116,154.552285 116,154 L116,106.828427 C116,106.297994 116.210714,105.789286 116.585786,105.414214 L120.87868,101.12132 C122.050253,99.9497475 122.050253,98.0502525 120.87868,96.8786797 L116.585786,92.5857864 C116.210714,92.2107137 116,91.7020059 116,91.1715729 L116,76 C116,75.4477153 116.447715,75 117,75 Z",
    id: "Rectangle-4-Copy-2",
    stroke: "#1063B8",
    strokeWidth: 2,
    fill: "#2F92F8",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119,86.3347107 L119,91.3944487 C119,91.7892987 119.116876,92.1753141 119.335899,92.5038491 L122,96.5 L122,101.5 L119,104.5 L119,137 L117,137 L117,107.328427 C117,106.797994 117.210714,106.289286 117.585786,105.914214 L119,104.5 L122,101.5 L122,96.5 L117.585786,92.0857864 C117.210714,91.7107137 117,91.2020059 117,90.6715729 L117,85 L117,78 L139,78 L139,83 L139,110.671573 C139,111.202006 138.789286,111.710714 138.414214,112.085786 L137,113.5 L134,116.5 L134,121.5 L138.414214,125.914214 C138.789286,126.289286 139,126.797994 139,127.328427 L139,135 L137,135 L137,126.605551 C137,126.210701 136.883124,125.824686 136.664101,125.496151 L134,121.5 L134,116.5 L137.009277,113.5 L137.001014,86.3347862 C131.000676,85.8884298 125.000338,85.8884046 119,86.3347107 Z",
    id: "Combined-Shape",
    fillOpacity: 0.147050498,
    fill: "#000000"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Combined-Shape",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#2F92F8",
    fillRule: "evenodd",
    xlinkHref: "#path-6"
  }), /*#__PURE__*/React.createElement("use", {
    fillOpacity: 0.100260417,
    fill: "#000000",
    fillRule: "evenodd",
    xlinkHref: "#path-6"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "black",
    fillOpacity: 1,
    filter: "url(#filter-7)",
    xlinkHref: "#path-6"
  }), /*#__PURE__*/React.createElement("use", {
    stroke: "#1063B8",
    strokeWidth: 2,
    xlinkHref: "#path-6"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Combined-Shape",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#2F92F8",
    fillRule: "evenodd",
    xlinkHref: "#path-8"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "black",
    fillOpacity: 1,
    filter: "url(#filter-9)",
    xlinkHref: "#path-8"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#1063B8",
    strokeWidth: 2,
    d: "M24.2665753,190.677796 L23.3355616,184.137729 L23.6300591,183.794099 C25.3669064,181.767487 26.0996766,180.70439 28.8328622,176.473224 C31.6620862,172.093383 33.4919556,169.804118 36.5253816,167.329721 L37.3002766,166.697631 L42.3569965,172.89679 L41.5821015,173.52888 C35.7940691,178.250239 30.4807908,183.42684 25.7044804,189 L24.2665753,190.677796 Z M43.8350037,171.727954 L38.9675453,165.379108 L39.7611511,164.770676 C45.9611823,160.017309 52.6039304,155.764362 59.6097538,152.062018 L60.493887,151.594783 L64.2317661,158.667849 L63.3476328,159.135084 C56.737272,162.628439 50.4724121,166.639265 44.6286094,171.119522 L43.8350037,171.727954 Z M65.8956583,157.818669 L62.360552,150.642108 L63.2576221,150.20022 C70.2743778,146.743832 77.5988665,143.844509 85.1469503,141.536121 L86.10323,141.243667 L88.4428594,148.893905 L87.4865798,149.186358 C80.3487169,151.369291 73.4240239,154.110267 66.7927284,157.37678 L65.8956583,157.818669 Z M90.2849516,148.358557 L88.1596068,140.646041 L89.1236714,140.380373 C96.678218,138.29856 104.407075,136.811193 112.230033,135.935273 L113.223823,135.824001 L114.114002,143.77432 L113.120213,143.885593 C105.714584,144.714785 98.398723,146.122638 91.2490162,148.092889 L90.2849516,148.358557 Z M115.940092,143.594717 L115.264211,135.623319 L116.260635,135.538833 C120.489804,135.180249 124.735771,135.000364 128.987422,135.000001 C132.60662,135 136.202066,135.129289 139.780331,135.387891 L140.777729,135.459974 L140.20107,143.439163 L139.203671,143.367081 C135.817468,143.122359 132.414365,143 128.987765,143.000001 C124.961839,143.000345 120.941137,143.170686 116.936517,143.510231 L115.940092,143.594717 Z M142.090992,143.602196 L142.889819,135.642178 L143.884821,135.742032 C151.754508,136.531794 159.500315,137.949189 167.053423,139.980062 L168.019124,140.239719 L165.94187,147.965326 L164.976169,147.705669 C157.842454,145.787563 150.524201,144.44851 143.085994,143.702049 L142.090992,143.602196 Z M167.752997,148.480402 L170.05244,140.817989 L171.010241,141.10542 C178.582828,143.377906 185.917593,146.267821 192.941266,149.745499 L193.83743,150.189222 L190.287643,157.358532 L189.391479,156.914809 C182.770315,153.636429 175.853821,150.911409 168.710799,148.767832 L167.752997,148.480402 Z M191.942087,158.208398 L195.702628,151.147355 L196.585258,151.617422 C203.556054,155.3299 210.170186,159.620286 216.358248,164.443849 L217.146944,165.058633 L212.228671,171.368197 L211.439976,170.753413 C205.615748,166.213457 199.388995,162.174441 192.824717,158.678466 L191.942087,158.208398 Z M213.677771,172.533518 L218.785328,166.376176 L219.554995,167.014621 C222.52792,169.480681 224.327531,171.772149 227.093122,176.135344 C229.842203,180.472491 230.561832,181.535222 232.313563,183.605645 L232.606237,183.951566 L231.631691,190.457691 L230.206231,188.772898 C225.429095,183.126658 220.15825,177.909119 214.447439,173.171963 L213.677771,172.533518 Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#2F92F8",
    fillRule: "evenodd",
    xlinkHref: "#path-10"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "black",
    fillOpacity: 1,
    filter: "url(#filter-11)",
    xlinkHref: "#path-10"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#1063B8",
    strokeWidth: 2,
    d: "M24,97 L44,97 C45.6568542,97 47,98.3431458 47,100 L47,206 C47,207.656854 45.6568542,209 44,209 L24,209 C22.3431458,209 21,207.656854 21,206 L21,100 C21,98.3431458 22.3431458,97 24,97 Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle-Copy",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#2F92F8",
    fillRule: "evenodd",
    xlinkHref: "#path-12"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "black",
    fillOpacity: 1,
    filter: "url(#filter-13)",
    xlinkHref: "#path-12"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#1063B8",
    strokeWidth: 2,
    d: "M212,96 L232,96 C233.656854,96 235,97.3431458 235,99 L235,205 C235,206.656854 233.656854,208 232,208 L212,208 C210.343146,208 209,206.656854 209,205 L209,99 C209,97.3431458 210.343146,96 212,96 Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M210,92 L230,92 L230,119 C223.333333,114.333333 216.666667,110.166667 210,106.5 C210,105.833333 210,101 210,92 Z",
    id: "Rectangle-5",
    fillOpacity: 0.148918705,
    fill: "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26,97 L46,97 C46,110.666667 46,118.166667 46,119.5 C39.3333333,114.666667 32.6666667,110.5 26,107 L26,97 Z",
    id: "Rectangle-5-Copy",
    fillOpacity: 0.148918705,
    fill: "#000000",
    transform: "translate(36.000000, 108.250000) scale(-1, 1) translate(-36.000000, -108.250000) "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Rectangle-6",
    fillOpacity: 0.148918705,
    fill: "#000000",
    points: "76 82 89 82 89 90.5 76 94"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Rectangle-6-Copy",
    fillOpacity: 0.148918705,
    fill: "#000000",
    transform: "translate(173.500000, 88.000000) scale(-1, 1) translate(-173.500000, -88.000000) ",
    points: "167 82 180 82 180 90 167 94"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Combined-Shape",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#2F92F8",
    fillRule: "evenodd",
    xlinkHref: "#path-14"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "black",
    fillOpacity: 1,
    filter: "url(#filter-15)",
    xlinkHref: "#path-14"
  }), /*#__PURE__*/React.createElement("use", {
    stroke: "#1063B8",
    strokeWidth: 2,
    xlinkHref: "#path-14"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(172.000000, 140.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "color",
    transform: "translate(6.017544, 6.017544)",
    fill: "url(#linearGradient-16)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M66.9824561,33.9823519 C66.9824561,52.2078274 52.2078026,66.9824561 33.9824561,66.9824561 C15.7571097,66.9824561 0.98245614,52.2078274 0.98245614,33.9823519 C0.98245614,15.7568763 15.7571097,0.98245614 33.9824561,0.98245614 C52.2078026,0.98245614 66.9824561,15.7568763 66.9824561,33.9823519 Z",
    id: "new-color-gradient"
  })), /*#__PURE__*/React.createElement("g", {
    id: "chrome"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M40,-0.75 C62.505585,-0.75 80.75,17.4943905 80.75,40 C80.75,62.5057585 62.5056626,80.75 40,80.75 C17.4943374,80.75 -0.75,62.5057585 -0.75,40 C-0.75,17.4943905 17.494415,-0.75 40,-0.75 Z M40,71.5307018 C57.4138681,71.5307018 71.5307018,57.4139095 71.5307018,39.9998895 C71.5307018,22.5860572 57.4138347,8.46929825 40,8.46929825 C22.5860214,8.46929825 8.46929825,22.5859801 8.46929825,39.9998895 C8.46929825,57.4139866 22.585988,71.5307018 40,71.5307018 Z",
    strokeOpacity: 0.398012908,
    stroke: "#000000",
    strokeWidth: 1.5,
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.62127154,29 C1.01611367,31.7308962 0.697010187,34.5693721 0.697010187,37.4823786 C0.697010187,59.039472 18.1724872,76.5149491 39.7295806,76.5149491 C61.286674,76.5149491 78.7621511,59.039472 78.7621511,37.4823786 C78.7621511,34.5693721 78.4430476,31.7308962 77.8378897,29 C78.8929272,32.572935 79.4591613,36.3555517 79.4591613,40.2704194 C79.4591613,62.2124609 61.6716221,80 39.7295806,80 C17.7875391,80 0,62.2124609 0,40.2704194 C0,36.3555517 0.566234058,32.572935 1.62127154,29 Z",
    id: "chrome-bottom-shadow",
    fillOpacity: 0.0299999993,
    fill: "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.4620499,63.0560662 C8.59301822,56.7838148 5,48.3553642 5,39.0877193 C5,19.709307 20.709307,4 40.0877193,4 C59.4661316,4 75.1754386,19.709307 75.1754386,39.0877193 C75.1754386,48.3553642 71.5824204,56.7838148 65.7133887,63.0560662 C70.7381129,57.1722306 73.7719298,49.5368995 73.7719298,41.1929825 C73.7719298,22.5897067 58.6909951,7.50877193 40.0877193,7.50877193 C21.4844435,7.50877193 6.40350877,22.5897067 6.40350877,41.1929825 C6.40350877,49.5368995 9.43732566,57.1722306 14.4620499,63.0560662 Z",
    id: "chrome-top-shadow",
    fillOpacity: 0.07,
    fill: "#000000"
  }), /*#__PURE__*/React.createElement("g", {
    id: "surround"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#FFFFFF",
    xlinkHref: "#path-18"
  }), /*#__PURE__*/React.createElement("path", {
    strokeOpacity: 0.25,
    stroke: "#000000",
    strokeWidth: 1.5,
    d: "M40.0001095,15.25 C53.6691933,15.25 64.75,26.3308646 64.75,40 C64.75,53.6691354 53.6691933,64.75 40.0001095,64.75 C26.3309861,64.75 15.25,53.6690958 15.25,40 C15.25,26.3309042 26.3309861,15.25 40.0001095,15.25 Z",
    fillOpacity: 0.0700000003,
    fill: "url(#linearGradient-17)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M39.9998878,29 C46.0749753,29 51,33.9246965 51,40 C51,46.0750791 46.0749753,51 39.9998878,51 C33.9248003,51 29,46.0750791 29,40 C29,33.9246965 33.9248003,29 39.9998878,29 L39.9998878,29 Z",
    id: "bevel",
    fillOpacity: 0.0808140851,
    fill: "#000000"
  })), /*#__PURE__*/React.createElement("g", {
    id: "keyhole",
    transform: "translate(35.438596, 22.438596)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    fill: "black",
    fillOpacity: 1,
    filter: "url(#filter-20)",
    xlinkHref: "#path-19"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#354856",
    fillRule: "evenodd",
    xlinkHref: "#path-19"
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgScimBridge);
export default __webpack_public_path__ + "static/media/scim-bridge.19b8b0b192958c414b0dd47e1014decd.svg";
export { ForwardRef as ReactComponent };